import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as rxjs from 'rxjs'

import * as me from '../../me'
import * as schema from '../schema'

import { Api } from './api.service'
import * as effects from './effects'
import type { TypeParams } from './types'

/** @see {@link ec.Collection} */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(me.Feature)

  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)

  constructor() {
    const schemaFeature = ngCore.inject(schema.Feature)

    super({
      api: ngCore.inject(Api),
      context$: schemaFeature.selectors.schema.asObservable.pipe(
        rxjs.map(_schema => _schema.enums),
      ),
      identify: entity => entity.id,
      name: ec.Name.Predefined.DmsEnum,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory({
            rowConfig: ({ entity, rowIdx }) => ({
              onClick: () => {
                const source = `EnumList.Table.Row-${rowIdx}.Clicked`

                this.plugins.currentEntityPlugin.storage.actions.putInIdLookup
                  .from(source)
                  .dispatch({
                    value: entity.id,
                  })

                const url = this._meFeature.contexts.selectors
                  .getUrlForLink({
                    goto: {
                      navigationId: ents.extra.prebuilt.AppPageAlias.Enum,
                    },
                  })
                  .asSignal()

                if (url) {
                  this._router.actions.navigate.from(source).dispatch({ url })
                }
              },
            }),
          }),
        ],
        currentList: {
          sortBy: { get: () => 'name' },
        },
      },
    })

    this.feature.registerEffects(
      effects.triggerSchemaLoadOnTableRefresh(
        this,
        schemaFeature,
        this._meFeature,
      ),
    )
  }
}
